import { Component, OnDestroy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'

@Component({
    templateUrl: './material-analytics.component.html',
    standalone: true,
    imports: [
        FormsModule,
        WjInputModule,
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
        NgbNavOutlet,
    ],
})
export class MaterialAnalyticsComponent extends BaseComponent implements OnDestroy {
    faSearch = faSearch
    active = 3
    startDate: Date
    endDate: Date
    jobGrid: Grid<any>
    jobVendorGrid: Grid<any>
    usageGrid: Grid<any>
    tripsGrid: Grid<any>
    pastDays = 30
    hourThreshold = 1

    constructor() {
        super()
        const now = new Date().date()
        this.startDate = new Date(now.getFullYear(), now.getMonth(), 1)
        this.endDate = now

        this.jobGrid = new Grid<any>(this.services).wrapColumnHeaders()
        this.jobVendorGrid = new Grid<any>(this.services).wrapColumnHeaders()
        this.usageGrid = new Grid<any>(this.services).wrapColumnHeaders()
        this.tripsGrid = new Grid<any>(this.services).wrapColumnHeaders()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.post('/api/MaterialAnalytics/GetAnalytics', { startDate: this.startDate, endDate: this.endDate }),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.jobGrid.items = result[0].jobTotals
                        this.jobVendorGrid.items = result[0].jobTotalsByVendor
                        this.usageGrid.items = result[0].materialTotals
                        this.tripsGrid.items = result[0].materialTruckTrips
                    },
                }),
        )
    }

    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }
}
